export enum SurveyResponsesSortEnum {
  CREATION_DATE_DSC,
  CREATION_DATE_ASC
}
